import { Box, Paper, Stack, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useSearchParams } from "react-router-dom";
import RemainingInventoryReport from "./RemainingInventoryRpt";

const REPORTS = {
  remaining: {
    title: "Remaining Inventory Report",
    description: "Stock on hand as of a selected date, patterned after rptStockOnHand.",
  },
  movement: {
    title: "Stock Movement Report",
    description: "Review inventory receipts, releases, transfers, and running balances.",
  },
  aging: {
    title: "Aging of Inventory Report",
    description: "Analyze how long current inventory has remained in stock.",
  },
  critical: {
    title: "Critical Inventory Report",
    description: "Identify items below their required or reorder stock levels.",
  },
};

const InventoryReports = () => {
  const [params] = useSearchParams();
  const reportKey = params.get("report") || "remaining";
  const report = REPORTS[reportKey] || REPORTS.remaining;

  return (
    <Box m={{ xs: 1.5, md: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
        <AssessmentOutlinedIcon fontSize="large" />
        <Box>
          <Typography variant="h3" fontWeight={800}>{report.title}</Typography>
          <Typography color="text.secondary">{report.description}</Typography>
        </Box>
      </Stack>

      {reportKey === "remaining" ? <RemainingInventoryReport /> : (
        <Paper elevation={0} sx={{ minHeight: 420, p: 3, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
          <Typography color="text.secondary">Report filters and results will be displayed here.</Typography>
        </Paper>
      )}
    </Box>
  );
};

export default InventoryReports;
